import { Collapse } from "react-bootstrap";
import Typography from "../../../../../../../common/Typography";
import ChevronDown from "../../../../../../../assets/ChevronDown";
import LayersThree01 from "../../../../../../../assets/LayersThree01";
import { getCategoryWiseItems, getExcludeItemTermText } from "../../../utils";

const ExcludeItemsTerms = ({
  textColor,
  pointsBranding,
  currStoreExcludeItem,
  isExcludeItemCollapse,
  handleExcludeItemCollapse,
}) => {
  const excludeItemTermText = getExcludeItemTermText(pointsBranding);
  return (
    <div className="exclude-item-terms">
      <div
        onClick={handleExcludeItemCollapse}
        className="exclude-item-term-head"
      >
        <Typography customClass="term" style={{ color: textColor }}>
          {`*${excludeItemTermText?.replace(".", " :")}`}
        </Typography>
        <ChevronDown
          width={14}
          height={14}
          color={textColor}
          rotate={isExcludeItemCollapse ? 180 : 0}
        />
      </div>
      <Collapse in={isExcludeItemCollapse}>
        <div className="exclude-item-term-body">
          {getCategoryWiseItems(currStoreExcludeItem?.list || [])?.map(
            (category) => (
              <div key={category?.category_id} className="category-item-div">
                <div className="category-head">
                  <LayersThree01 width={12} height={12} color={textColor} />
                  <Typography
                    weight="medium"
                    size="text-xs"
                    style={{ color: textColor }}
                  >
                    {category?.category_name}
                  </Typography>
                </div>
                <Typography
                  size="text-xs"
                  customClass="item-names"
                  style={{ color: textColor }}
                >
                  {category?.category_items?.length > 0 &&
                    category?.category_items
                      ?.map((category) => `• ${category?.name}`)
                      ?.join(" ")}
                </Typography>
              </div>
            )
          )}
        </div>
      </Collapse>
    </div>
  );
};
export default ExcludeItemsTerms;
